import { useQuery } from "@tanstack/react-query";
import { BlockItem, TreeViewTableItem } from "@/apis/preview/v2/types";
import queries from "@/queries";
import { useWorkbookIdAndTableId } from "../hook";

export interface TreeViewData {
  items: TreeViewTableItem[];
  blockItems: BlockItem[];
}

export const useNotUsedSumTagKeys = () => {
  const {
    data: { workbookId, tableId },
  } = useWorkbookIdAndTableId();

  const { data, isLoading } = useQuery({
    ...queries
      .workbook(workbookId!)
      ._ctx.tables(tableId!)
      ._ctx.notUsedSumTagKeys(),
    enabled: !!workbookId && !!tableId,
  });

  return { data, isLoading };
};

export const useNotUsedSumTagKeysWithWorkbookIdAndTableId = (
  workbookId: string,
  tableId: string,
) => {
  const { data, isLoading } = useQuery({
    ...queries
      .workbook(workbookId)
      ._ctx.tables(tableId)
      ._ctx.notUsedSumTagKeys(),
    enabled: !!workbookId && !!tableId,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });

  return { data, isLoading };
};
